// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-logs-wrapper {
  background-color: #ffffff;
}
.ultimate-security-logs-wrapper .datatable-unit .datatable-filters span.active {
  color: #5007aa;
}
.ultimate-security-logs-wrapper .datatable-unit .datatable-filters span {
  color: #000;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  display: block;
  cursor: pointer;
}
.ultimate-security-logs-wrapper .datatable-unit .datatable-filters span + span {
  border-left: 1px solid rgba(29, 35, 39, 0.5019607843);
  margin-left: 8px;
  padding-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Logs/Logs.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;AACD;AACC;EACC,cAAA;AACF;AAEC;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAGC;EACC,qDAAA;EACA,gBAAA;EACA,iBAAA;AADF","sourcesContent":[".ultimate-security-logs-wrapper {\n\tbackground-color: #ffffff;\n\t// padding: 30px;\n\t.datatable-unit .datatable-filters span.active {\n\t\tcolor: #5007aa;\n\t}\n\n\t.datatable-unit .datatable-filters span {\n\t\tcolor: #000;\n\t\tfont-weight: 400;\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tletter-spacing: 1%;\n\t\tdisplay: block;\n\t\tcursor: pointer;\n\t}\n\n\t.datatable-unit .datatable-filters span + span {\n\t\tborder-left: 1px solid rgba(29, 35, 39, 0.5019607843);\n\t\tmargin-left: 8px;\n\t\tpadding-left: 8px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
